/* global  L */

import Map, { streetLayer, satelliteLayer } from './Map'
import MapboxOS from './maps/mapboxOS'

if (document.getElementById('arrivalMap') !== null) {
    // Load Ordinance survey projection for Leaflet Map
    MapboxOS()

    const arrivalMap = new Map('arrivalMap', {
        coords: [50.1016, -5.2750],
        maxZoom: 19,
        minZoom: 7,
        zoom: 7,
        scrollWheelZoom: false,
    }, {
        Streets: streetLayer(),
        Satellite: satelliteLayer(),
        'Ordnance Survey': L.OSMap.tilelayer('qOGSRiomYmUUAki6J2BZrtZcUVWMl4aS', {maxZoom: 10}),
    })

    const cottageLat = parseFloat(document.getElementById('arrivalMap').getAttribute('data-lat'))
    const cottageLng = parseFloat(document.getElementById('arrivalMap').getAttribute('data-lng'))
    const cottageName = document.getElementById('arrivalMap').getAttribute('data-name')

    arrivalMap.addMarker([cottageLat, cottageLng], {
        title: cottageName,
        icon: L.icon({
            iconUrl: '/media/map/icon-home.png',
            iconSize: [33, 47],
            iconAnchor: [17, 46],
            popupAnchor: [0, -40],
        }),
        zIndexOffset: 100,
        riseOnHover: true,
    })

    arrivalMap.fitMarkers({ padding: [40, 40], maxZoom: 14 })
}
